const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChair1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 56.25 104.02",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.38,
    y: 51.35,
    width: 55.5,
    height: 5.29,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.72,
    y: 0.38,
    width: 46.8,
    height: 15.04,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "14.34 51.35 10.16 51.35 8.49 15.42 12.66 15.42 14.34 51.35",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.06 51.35 20.88 51.35 20.05 15.42 24.23 15.42 25.06 51.35",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.37 51.35 31.19 51.35 32.02 15.42 36.2 15.42 35.37 51.35",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.09 51.35 41.91 51.35 43.59 15.42 47.76 15.42 46.09 51.35",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "9.07 103.65 5.22 103.65 5.05 57.15 11.74 57.15 9.07 103.65",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.18 103.65 51.03 103.65 51.2 57.15 44.51 57.15 47.18 103.65",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChair1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chair1.b849e4336591fead0ea76d2451bfbdea.svg";